/**
 * @typedef {object} Express
 * @typedef {object} Zone
 */

class Service {
	/**
	 * @param  {object} options
	 * @param  {object} options.request
	 * @param  {Zone[]} options.zones
	 *
	 * @returns {object}
	 */
	async getZonesResponse(options = {}) {
		const { request, zones } = options;
		return {
			contentType: 'application/javascript',
			body: ''
		};
	}

	/**
	 * @param  {object} options
	 * @param  {Express} options.app
	 * @param  {string} options.hostname
	 * @param  {number} options.port
	 * @param  {boolean} options.isSecure
	 * @param  {Function} options.render
	 *
	 * @returns {Express}
	 */
	setupServer(options = {}) {
		const { app, zones, hostname, port, isSecure, render } = options;
		return app;
	}
}

export default Service;
